<script lang="ts" setup>
const props = defineProps<{
  templateId: string
}>()

const { t } = useI18n()

const { data, isFetching } = useQueryTemplate.related({
  id: props.templateId,
  useQueryOptions: {
    placeholderData: (previousData: any) => previousData,
    retry: false,
  },
})

const isFetchingDelayed = refDelayed(isFetching, false)
const relatedTemplates = computed(() => data.value?.data || [])
</script>

<template>
  <span class="mb-3 block font-semibold">
    {{ t('template.related-templates.heading') }}
  </span>
  <DTLoaderDots v-if="isFetchingDelayed" />
  <DTNavList
    v-else-if="relatedTemplates.length"
    class="-ml-3"
  >
    <DTNavItem
      v-for="relatedTemplate in relatedTemplates"
      :key="relatedTemplate.id"
      component-class="text-left"
      :to="{
        name: '2-template-templateId',
        params: {
          templateId: relatedTemplate.id,
        },
      }"
    >
      {{ relatedTemplate.attributes.name }}
    </DTNavItem>
  </DTNavList>
  <span
    v-else
    class="text-sm text-gray-500"
  >
    {{ t('template.related-templates.empty-text') }}
  </span>
</template>
